import { ExternalIdentityMappingSyncResponseSchema, ExternalInvitationListSchema, ExternalInvitationRecoveryResponseSchema, ExternalInvitationSchema,
  ExternalInvitationWriteResponseSchema, ExternalPersonCandidateListSchema } from '@youkuai/contracts';
import { apiRequest } from './project-api.ts';

export async function listExternalInvitations(token: string) {
  return ExternalInvitationListSchema.parse(await apiRequest('/system/external-invitations', token));
}
export async function listExternalPersonCandidates(token: string, query: string) {
  return ExternalPersonCandidateListSchema.parse(await apiRequest(
    `/system/external-invitations/candidates?q=${encodeURIComponent(query)}`, token));
}
export async function syncExternalIdentityMappings(token: string) {
  return ExternalIdentityMappingSyncResponseSchema.parse(await apiRequest(
    '/system/external-invitations/identity-mappings/sync', token, { method: 'POST' }));
}
export async function createExternalInvitation(token: string, input: unknown) {
  return ExternalInvitationWriteResponseSchema.parse(await apiRequest('/system/external-invitations', token, {
    method: 'POST', headers: { 'content-type': 'application/json',
      'idempotency-key': `external-invitation-${crypto.randomUUID()}` }, body: JSON.stringify(input),
  }));
}
export async function reconcileExternalInvitation(token: string, id: string) {
  return ExternalInvitationSchema.parse(await apiRequest(
    `/system/external-invitations/${encodeURIComponent(id)}/reconcile`, token, { method: 'POST' }));
}
export async function redeliverExternalInvitation(token: string, id: string) {
  return ExternalInvitationRecoveryResponseSchema.parse(await apiRequest(
    `/system/external-invitations/${encodeURIComponent(id)}/redeliver`, token, { method: 'POST' }));
}
export async function cancelExternalInvitation(token: string, id: string) {
  return ExternalInvitationSchema.parse(await apiRequest(
    `/system/external-invitations/${encodeURIComponent(id)}/cancel`, token, { method: 'POST' }));
}
